import { facadeApi } from 'api'
import { TenantDefault } from 'types/tenants/tenant'

export const fetchDefaultTenantApi = () => facadeApi.get<TenantDefault>('/tenants/default')
